import React from 'react'
import './styles.scss'

interface ButtonProps {
  children?: any
  color:
    | 'primary'
    | 'primary-light'
    | 'success'
    | 'tag'
    | 'tag-active'
    | 'warning'
    | 'danger'
    | 'link-danger'
    | 'default'
    | 'orange-outline'
  type: 'button' | 'reset' | 'submit'
  size?: 'small' | 'normal' | 'large'
  /** Borda e fundo transparente, cores alinhadas ao `color` */
  outline?: boolean
  styles?: any
  disabled?: boolean

  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  icon?: string
  iconPosition?: 'left' | 'right'
  iconStyles?: any
  className?: string
  title?: string
  dataTestId?: string
  ariaLabel?: string
}

const defaultProps: ButtonProps = {
  children: <></>,
  color: 'primary',
  type: 'button',
  size: 'normal',
  outline: false,
  styles: {},
  disabled: false,
  onClick: () => {},
  icon: '',
  iconPosition: 'left',
  iconStyles: {},
  title: '',
}

const Button: React.FunctionComponent<ButtonProps> = ({
  children,
  color,
  type,
  size,
  outline,
  styles,
  onClick,
  disabled,
  icon,
  iconPosition,
  className,
  iconStyles,
  title,
  dataTestId,
  ariaLabel,
}) => {
  const rootClass = ['root', color, size, outline ? 'outline' : '', className]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      className={rootClass}
      style={styles}
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    >
      {icon && iconPosition === 'left' && (
        <img src={icon} alt="Icon Button" style={iconStyles} />
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <img src={icon} alt="Icon Button" style={iconStyles} />
      )}
    </button>
  )
}

Button.defaultProps = defaultProps

export default Button
